import { render, staticRenderFns } from "./SidebarSmall.vue?vue&type=template&id=955f7cce&"
import script from "./SidebarSmall.vue?vue&type=script&lang=js&"
export * from "./SidebarSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports